<template>
    <div class="container-fluid bg-dark p-4 d-flex flex-column justify-content-center align-items-center">
        <p class="text-center text-white h3">Tadeo Alvarez &copy; Todos los derechos reservados</p>
        <p class="text-center text-white">Todas las recetas aqui vistas fueron tomadas de: <a class="text-white" href="https://www.cocinafacil.com.mx/">Cocina-Facil.com.mx</a></p>
        <a class="text-center text-white" href="https://www.flaticon.com/free-icons/page-not-found" title="page not found icons">Page not found icon creado por smashingstocks - Flaticon</a>
    </div>
</template>

<script>
export default { 
    name: "TheFooter"
}
</script>
